import React from "react";
import { Link } from "react-router-dom";

export default function Tagline({ variant = "site" }) {
  const isHome = variant === "home";

  return (
    <>
      <section className="flex flex-col justify-center text-center gap-4 max-w-7xl">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-black">
          {isHome
            ? "Des automatisations et des apps sur mesure pour votre business"
            : "Des sites web sur-mesure pour présenter votre activité"}
        </h1>
        <p className="font-medium">
          {isHome
            ? <>Je vous aide à automatiser et structurer vos tâches <br />de l'idéation à la mise en production</>
            : <>Nous créons votre site vitrine sur-mesure pour présenter <br />votre produit ou votre service</>}
        </p>
      </section>
      <div className="flex gap-4 justify-center mt-8">
<Link
          to="https://wa.me/message/4QESRNQVOAAXK1"
          target="_blank"
          className="border border-secondary text-main py-3 px-4 bg-secondary rounded-[64px]"
        >
          Me contacter →
        </Link>
      </div>
    </>
  );
}
